module.exports = __webpack_public_path__ + "img/mrbanxe.43d5c5f7.png";